import './Slot.scss';
import ImportExportRoundedIcon from '@mui/icons-material/ImportExportRounded';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { Button, SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import { ISlotList, SlotProps } from './ISlot';
import { FunctionComponent, useEffect, useState } from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getSlot } from '../../Redux/Slicers/Slot/SlotSlicer';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import SlotForm from './SlotForm';
import FixtureForm from './FixtureForm';
import { ReactComponent as View } from '../../Assets/Images/solar_eye-linear.svg';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { FormikProps } from 'formik';
import {
  clearUpdateSlotState,
  SlotsUpdateableData,
} from '../../Redux/Slicers/Slot/UpdateSlotSlicer';
import {
  clearDeleteSlot,
  deleteSlot,
} from '../../Redux/Slicers/Slot/DeleteSlotSlice';
import { clearAddSlotState } from '../../Redux/Slicers/Slot/AddSlotSlicer';
import { useParams } from 'react-router-dom';
import { getParkingType } from '../../Redux/Slicers/ParkingType/ParkTypeSlicer';
import CustomFooter from '../../Components/Table/components/CustomFooter';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { Cancel } from '@mui/icons-material';
import {
  clearFixtureState,
  getFixture,
} from '../../Redux/Slicers/Fixtures/FixtureSlicer';
import { FixturesUpdateableData } from '../../Redux/Slicers/Fixtures/UpdateFixtureSlicer';
import SpaceForm from './SpaceForm';
import { SpacesUpdateableData } from '../../Redux/Slicers/Space/UpdateSpaceSlicer';
import {
  clearSpaceState,
  getSpace,
} from '../../Redux/Slicers/Space/SpaceSlicer';
import { deleteFixture } from '../../Redux/Slicers/Fixtures/DeleteFixtureSlice';
import { deleteSpace } from '../../Redux/Slicers/Space/DeleteSpaceSlice';

import { Badge } from 'primereact/badge';
import FixtureOrder from './FixtureOrder';
import {
  clearUpdateableDataOrder,
  clearUpdateFixtureStateOrder,
} from '../../Redux/Slicers/Fixtures/UpdateFixtureOrderSlicer';
import LevelOrder from './LevelOrder';
import { clearUpdateSlotStateOrder } from '../../Redux/Slicers/Slot/UpdateSlotOrderSlicer';
import DisplayForm from './DisplayForm';
import {
  clearDisplayDeviceState,
  getDisplayDevice,
} from '../../Redux/Slicers/DisplayDevice/DisplayDeviceSlicer';
import {
  clearAddDisplayDeviceState,
} from '../../Redux/Slicers/DisplayDevice/AddDisplayDeviceSlicer';
import {
  clearUpdateDisplayDeviceState,
  DisplayDeviceUpdateableData,
} from '../../Redux/Slicers/DisplayDevice/UpdateDisplayDeviceSlicer';
import {
  clearDeleteDisplayDevice,
  deleteDisplayDevice,
} from '../../Redux/Slicers/DisplayDevice/DeleteDisplayDeviceSlice';
import SpaceOrder from './SpaceOrder';
import LevelCalibrateModal from './LevelCalibrateModal';
import FixtureBeaconModal from './FixtureBeaconModal';
import StraightenIcon from '@mui/icons-material/Straighten';
import PlaceIcon from '@mui/icons-material/Place';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import { Tooltip } from '@mui/material';
import api from '../../Redux/Axios/middleware';

interface LevelComponentProps {
  lvalue: {
    level_id: string;
    level_diagram: string;
  };
}
const Slot: FunctionComponent<SlotProps> = () => {
  const { id }: any = useParams();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [fixtureorder, setfixtureorder] = useState<boolean>(false);
  const [levelorder, setlevelorder] = useState<boolean>(false);
  const [spaceorder, setspaceorder] = useState<boolean>(false);

  const [opens, setOpens] = useState<boolean>(false);
  const [openorderF, setOpenorderF] = useState<boolean>(false);

  const [lvalue, setLvalue] = useState<LevelComponentProps | null>(null);
  const [calibrateLevel, setCalibrateLevel] = useState<any | null>(null);
  const [placeFixture, setPlaceFixture] = useState<any | null>(null);
  const [clearPlacementTarget, setClearPlacementTarget] = useState<any | null>(
    null
  );
  const [clearingPlacement, setClearingPlacement] = useState(false);
  const [clearPlacementError, setClearPlacementError] = useState<string | null>(
    null
  );

  const [_leval, setLeval] = useState<boolean>(false);
  const [_fixture, setFixture] = useState<boolean>(false);
  const [_space, setSpace] = useState<boolean>(false);
  const [_display, setDisplay] = useState<boolean>(false);
  const [screenshotDevice, setScreenshotDevice] = useState<any>(null);

  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>('');
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [deletepage, setDeletepage] = useState<string>('');

  const [formik, setFormik] = useState<FormikProps<ISlotList>>();
  const [selectedLevelId, setSelectedLevelId] = useState<string | null>(
    () => localStorage.getItem('selectedLevelId') // Initialize from localStorage
  );

  useEffect(() => {
    if (selectedLevelId) {
      localStorage.setItem('selectedLevelId', selectedLevelId); // Save to localStorage on change
    }
  }, [selectedLevelId]);
  const { data: updateFixtureOrders, updateableData } = useAppSelector(
    (state: any) => state?.UpdateFixtureOrder
  );
  const { data: updateSlotOrders } = useAppSelector(
    (state: any) => state?.UpdateSlotOrder
  );

  const { data: updateSpaceOrders } = useAppSelector(
    (state: any) => state?.UpdateSpaceOrder
  );
  useEffect(() => {
    if (updateFixtureOrders?.response) {
      setfixtureorder(true);
    }
  }, [updateFixtureOrders]);

  useEffect(() => {
    if (updateSlotOrders?.response) {
      setlevelorder(true);
      console.log(updateSlotOrders);
    }
  }, [updateSlotOrders]);

  const { data } = useAppSelector((state) => state.Slot);
  const { data: space } = useAppSelector((state) => state.Space);
  const { data: fixture } = useAppSelector((state) => state.Fixture);

  const { data: updateSlot, updateableDate } = useAppSelector(
    (state) => state.UpdateSlot
  );

  const { data: updateFixture, fixupdateableDate } = useAppSelector(
    (state) => state.UpdateFixture
  );
  const { data: updateSpace, spaceupdateableDate } = useAppSelector(
    (state) => state.UpdateSpace
  );
  const { data: addSlot } = useAppSelector((state) => state?.AddSlot);
  const { data: addFixture } = useAppSelector((state) => state?.AddFixture);
  const { data: addSpace } = useAppSelector((state) => state?.AddSpace);

  const { data: deleteLevelData } = useAppSelector((state) => state.DeleteSlot);
  const { data: deleteFixtureData } = useAppSelector(
    (state) => state.DeleteFixture
  );
  const { data: deleteSpaceData } = useAppSelector(
    (state) => state.DeleteSpace
  );
  const { data: displayDeviceData } = useAppSelector((state: any) => state.DisplayDevice);
  const { data: addDisplayDevice } = useAppSelector((state: any) => state.AddDisplayDevice);
  const { data: updateDisplayDeviceResp, updateableDate: displayUpdateableDate } = useAppSelector(
    (state: any) => state.UpdateDisplayDevice
  );
  const { data: deleteDisplayDeviceData } = useAppSelector((state: any) => state.DeleteDisplayDevice);
  const isDisplayUpdateable = displayUpdateableDate && Object.keys(displayUpdateableDate).length !== 0;

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;

  const isFixUpdateable =
    fixupdateableDate && Object.keys(fixupdateableDate).length !== 0;

  const isSpaceUpdateable =
    spaceupdateableDate && Object.keys(spaceupdateableDate).length !== 0;
  useEffect(() => {
    const id = localStorage.getItem('level');
    if (id) {
      dispatch(getFixture(id));
    }
  }, [
    addFixture,
    updateFixture,
    deleteFixtureData,
    addSpace,
    deleteSpaceData,
    updateFixtureOrders,
  ]);

  useEffect(() => {
    const id = localStorage.getItem('fixture');
    if (id) {
      console.log('fixture', id);

      dispatch(getSpace(id));
    }
  }, [addSpace, updateSpace, deleteSpaceData, updateSpaceOrders]);

  useEffect(() => {
    dispatch(getSlot(id));
  }, [
    isUpdateable,
    addSlot,
    addFixture,
    deleteFixtureData,
    deleteLevelData,
    updateSlot,
    updateSlotOrders,
  ]);

  useEffect(() => {
    dispatch(getDisplayDevice(id));
  }, [id, addDisplayDevice, updateDisplayDeviceResp, deleteDisplayDeviceData]);
  // const masterData:any = Slot.map((master, index) => ({
  //   ...master,
  //   id: master._id,
  //   index: index + 1,
  // }));

  const level: Columns = [
    {
      field: 'level_id',
      renderHeader: () => <b>Level</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
    },

    {
      field: 'fixtureCount',
      renderHeader: () => <b>Fixture</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
      renderCell: (params) => <Badge value={params.value}></Badge>,
    },

    {
      field: 'level_diagram',
      renderHeader: () => <b>Diagram</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 250,
      renderCell: (params) => {
        const mpp = params.row?.diagram_calibration?.meters_per_pixel;
        const calibrated =
          mpp != null && Number.isFinite(Number(mpp));
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/${params.value}`}
              alt="Level Diagram"
              style={{ width: '100%', maxWidth: '100px', height: 'auto' }}
            />
            <span
              title={
                calibrated
                  ? `Calibrated — ${Number(mpp).toFixed(5)} m/px`
                  : 'Not calibrated'
              }
              style={{
                position: 'absolute',
                top: 2,
                right: 2,
                padding: '1px 5px',
                fontSize: 10,
                fontWeight: 700,
                color: '#fff',
                background: calibrated ? '#059669' : '#9ca3af',
                borderRadius: 3,
                lineHeight: '14px',
              }}>
              {calibrated ? 'm/px' : 'uncal.'}
            </span>
          </div>
        );
      },
    },

    {
      field: 'action',
      renderHeader: () => <b>Action</b>,
      flex: 2,
      type: 'actions',
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="View"
          label="View"
          icon={<View className="action_icons" />}
          onClick={() => {
            setOpens(true);
            setLeval(true);
            //   nav({
            //     pathname: `views`,
            // search: createSearchParams({
            // project: encode(params.row),
            // }).toString(),
            // });
            // dispatch(getOneLocation(params.row.id));
            console.log(params.row);
            setLvalue(params.row);
            // // dispatch(handoverScheduleViewData(params.row));
            // if (!SelectUpdateHandoverRespose?.isLoading) {

            // }
          }}
        />,
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(SlotsUpdateableData(params.row));
            setOpen(true);
            setLeval(true);
            // dispatch(getParkingType());
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? '');
            setDeleteableId(params.row.id!);
            setDeletepage('LE');
          }}
        />,

        <GridActionsCellItem
          key="Calibrate"
          label="Calibrate"
          icon={
            <StraightenIcon
              className="action_icons"
              titleAccess="Calibrate (set m/px, origin, rotation)"
            />
          }
          disabled={!params.row.level_diagram}
          onClick={() => {
            setCalibrateLevel({
              _id: params.row._id ?? params.row.id,
              level_id: params.row.level_id,
              level_diagram: params.row.level_diagram,
              diagram_calibration: params.row.diagram_calibration,
            });
          }}
        />,

        <GridActionsCellItem
          key="right"
          label="right"
          icon={
            <ArrowCircleRightIcon
              className={
                params.row.id === localStorage.getItem('level')
                  ? 'action_icon_active'
                  : 'action_icons'
              }
            />
          }
          onClick={() => {
            setSelectedLevelId(params.row.id); // Set selected level

            dispatch(getFixture(params.row.id));
            localStorage.setItem('level', params.row.id);
            dispatch(clearSpaceState());
            localStorage.setItem('fixture', '');
            localStorage.setItem('space', '');

            // setDeleteOpen(true);
            // setDeleteableName(params.row.name ?? '');
            // setDeleteableId(params.row.id!);
          }}
        />,
      ],
      cellClassName: 'action_cell',
    },
  ];

  const fixtures: Columns = [
    {
      field: 'fixture_id',
      renderHeader: () => <b>Fixture</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
    },

    {
      field: 'spaceCount',
      renderHeader: () => <b>Spaces</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
      renderCell: (params) => <Badge value={params.value}></Badge>,
    },

    {
      field: 'fixture_ip_address',
      renderHeader: () => <b>IP</b>,
      flex: 1,
      minWidth: 100,
      type: 'string',
      // maxWidth: 250,
    },

    {
      field: 'beacon_x_m',
      renderHeader: () => <b>X (m)</b>,
      flex: 0.6,
      minWidth: 72,
      type: 'string',
      valueGetter: (params) => {
        const v = params.row?.beacon?.x_m;
        return v != null && Number.isFinite(Number(v))
          ? Number(v).toFixed(2)
          : '—';
      },
    },
    {
      field: 'beacon_y_m',
      renderHeader: () => <b>Y (m)</b>,
      flex: 0.6,
      minWidth: 72,
      type: 'string',
      valueGetter: (params) => {
        const v = params.row?.beacon?.y_m;
        return v != null && Number.isFinite(Number(v))
          ? Number(v).toFixed(2)
          : '—';
      },
    },
    {
      field: 'placed',
      renderHeader: () => <b>Placed?</b>,
      flex: 0.6,
      renderCell: (params) => {
        const b = params.row?.beacon;
        const placed =
          b &&
          b.x_m != null &&
          b.y_m != null &&
          Number.isFinite(Number(b.x_m)) &&
          Number.isFinite(Number(b.y_m));
        return (
          <span
            style={{
              padding: '2px 8px',
              borderRadius: 4,
              fontSize: 12,
              fontWeight: 600,
              background: placed ? '#dcfce7' : '#f3f4f6',
              color: placed ? '#15803d' : '#6b7280',
            }}>
            {placed ? 'placed' : 'unplaced'}
          </span>
        );
      },
    },

    {
      field: 'action',
      renderHeader: () => <b>Action</b>,
      flex: 2.4,
      type: 'actions',
      getActions: (params: GridRowParams<any>) => {
        const mpp = params.row?.level_id?.diagram_calibration?.meters_per_pixel;
        const levelCalibrated =
          mpp != null && Number.isFinite(Number(mpp));
        const b = params.row?.beacon;
        const placed =
          b &&
          b.x_m != null &&
          b.y_m != null &&
          Number.isFinite(Number(b.x_m)) &&
          Number.isFinite(Number(b.y_m));
        return [
        <GridActionsCellItem
          key="View"
          label="View"
          icon={<View className="action_icons" />}
          onClick={() => {
            setOpens(true);
            setFixture(true);
            //   nav({
            //     pathname: `views`,
            // search: createSearchParams({
            // project: encode(params.row),
            // }).toString(),
            // });
            // dispatch(getOneLocation(params.row.id));
            console.log(params.row);
            setLvalue(params.row);
          }}
          //   nav({
          //     pathname: `views`,
          // search: createSearchParams({
          // project: encode(params.row),
          // }).toString(),
          // });
          // dispatch(getOneLocation(params.row.id));
          // console.log(params.row);

          // // dispatch(handoverScheduleViewData(params.row));
          // if (!SelectUpdateHandoverRespose?.isLoading) {

          // }
          // }}
        />,
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(FixturesUpdateableData(params.row));
            setOpen(true);
            setFixture(true);
            // dispatch(getParkingType());
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? '');
            setDeleteableId(params.row.id!);
            setDeletepage('FX');
            localStorage.getItem('fixture') == params.row.id &&
              localStorage.setItem('fixture', '');
          }}
        />,

        <GridActionsCellItem
          key="Place"
          label="Place on map"
          icon={
            <Tooltip
              title={
                levelCalibrated
                  ? 'Place on map'
                  : 'Calibrate this level first'
              }>
              <PlaceIcon
                className={
                  levelCalibrated ? 'action_icons' : 'action_icons'
                }
                style={{
                  opacity: levelCalibrated ? 1 : 0.35,
                }}
              />
            </Tooltip>
          }
          disabled={!levelCalibrated}
          onClick={() => {
            setPlaceFixture(params.row);
          }}
        />,

        <GridActionsCellItem
          key="ClearPlacement"
          label="Clear placement"
          icon={
            <Tooltip
              title={
                !levelCalibrated
                  ? 'Calibrate this level first'
                  : placed
                    ? 'Clear placement'
                    : 'Not placed'
              }>
              <LocationOffIcon
                className="action_icons"
                style={{
                  opacity: levelCalibrated && placed ? 1 : 0.35,
                }}
              />
            </Tooltip>
          }
          disabled={!levelCalibrated || !placed}
          onClick={() => {
            setClearPlacementError(null);
            setClearPlacementTarget(params.row);
          }}
        />,

        <GridActionsCellItem
          key="right"
          label="right"
          icon={
            <ArrowCircleRightIcon
              className={
                params.row.id === localStorage.getItem('fixture')
                  ? 'action_icon_active'
                  : 'action_icons'
              }
            />
          }
          onClick={() => {
            dispatch(getSpace(params.row.id));
            dispatch(getParkingType(id));
            localStorage.setItem('fixture', params.row.id);
          }}
        />,
      ];
      },
      cellClassName: 'action_cell',
    },
  ];

  const spaces: Columns = [
    {
      field: 'zone_id',
      renderHeader: () => <b>Zones</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
    },
    {
      field: 'space_id',
      renderHeader: () => <b>Spaces</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 50,
    },

    {
      field: 'parking_type',
      renderHeader: () => <b>Type</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 250,
      valueGetter: (params) => params.row.parking_type?.name || '',
    },
    {
      field: 'x',
      renderHeader: () => <b>X</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 250,
    },
    {
      field: 'y',
      renderHeader: () => <b>Y</b>,
      flex: 1,
      type: 'string',
      // maxWidth: 250,
    },

    {
      field: 'action',
      renderHeader: () => <b>Action</b>,
      flex: 2,
      type: 'actions',
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="View"
          label="View"
          icon={<View className="action_icons" />}
          onClick={() => {
            setOpens(true);
            setSpace(true);
            //   nav({
            //     pathname: `views`,
            // search: createSearchParams({
            // project: encode(params.row),
            // }).toString(),
            // });
            // dispatch(getOneLocation(params.row.id));
            console.log(params.row);
            setLvalue(params.row);
          }}
          //   nav({
          //     pathname: `views`,
          // search: createSearchParams({
          // project: encode(params.row),
          // }).toString(),
          // });
          // dispatch(getOneLocation(params.row.id));
          // console.log(params.row);

          // // dispatch(handoverScheduleViewData(params.row));
          // if (!SelectUpdateHandoverRespose?.isLoading) {

          // }
          // }}
        />,
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(SpacesUpdateableData(params.row));
            dispatch(getParkingType(id));
            setOpen(true);
            setSpace(true);
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? '');
            setDeleteableId(params.row.id!);
            setDeletepage('SP');
          }}
        />,

        // <GridActionsCellItem
        //   key="right"
        //   label="right"
        //   icon={<ArrowCircleRightIcon className="action_icons" />}
        //   onClick={() => {
        //     dispatch(getSpace(params.row.id));
        //     localStorage.setItem('space', params.row.id);

        //     // setDeleteOpen(true);
        //     // setDeleteableName(params.row.name ?? '');
        //     // setDeleteableId(params.row.id!);
        //   }}
        // />,
      ],
      cellClassName: 'action_cell',
    },
  ];
  // useEffect(() => {
  //   if (id) {
  //     dispatch(getSlot(id));
  //   }
  // }, []);

  const handleDialogClose = () => {
    setLvalue(null);
    setOpens(false);
    setLeval(false);
    setFixture(false);
    setSpace(false);
    setDisplay(false);
    setOpen(false);
    setfixtureorder(false);
    setScreenshotDevice(null);
  };

  const handleAddDisplay = () => {
    setLeval(false);
    setFixture(false);
    setSpace(false);
    setDisplay(true);
    setOpen(true);
  };

  const handleAddLevel = () => {
    setLeval(false);
    setFixture(false);
    setSpace(false);
    setOpen(true);
    setLeval(true);
  };

  const handleAddFixture = () => {
    setLeval(false);
    setFixture(false);
    setSpace(false);
    setOpen(true);
    setFixture(true);
  };

  const handleAddSpace = () => {
    setLeval(false);
    setFixture(false);
    setSpace(false);
    dispatch(getParkingType(id));
    setOpen(true);
    setSpace(true);
  };

  useEffect(() => {
    return () => {
      dispatch(clearAddSlotState());
      dispatch(clearUpdateSlotState());
      dispatch(clearDeleteSlot());
      dispatch(clearUpdateFixtureStateOrder());
      dispatch(clearUpdateableDataOrder());
      dispatch(clearUpdateSlotStateOrder());
      dispatch(clearDisplayDeviceState());
      dispatch(clearAddDisplayDeviceState());
      dispatch(clearUpdateDisplayDeviceState());
      dispatch(clearDeleteDisplayDevice());
    };
  }, []);

  const data1 = data?.response?.data;
  const masterData = Array.isArray(data1)
    ? data1.map((master, index) => ({
        ...master,
        id: master._id,
        index: index + 1,
      }))
    : [];

  const data2 = fixture?.response?.data;
  const masterData2 = Array.isArray(data2)
    ? data2.map((master, index) => ({
        ...master,
        id: master._id,
        index: index + 1,
      }))
    : [];

  const data3 = space?.response?.data;
  const masterData3 = Array.isArray(data3)
    ? data3.map((master, index) => ({
        ...master,
        id: master._id,
        index: index + 1,
      }))
    : [];

  const masterForm = (data: FormikProps<ISlotList>) => {
    setFormik(data);
  };

  const STALE_MS = 5 * 60 * 1000;
  const displayOnlineStatus = (device: any): string => {
    if (!device?.last_report?.reported_at) return 'unknown';
    const age = Date.now() - new Date(device.last_report.reported_at).getTime();
    return age > STALE_MS ? 'stale' : 'online';
  };

  const data4 = displayDeviceData?.response?.data;
  const masterData4 = Array.isArray(data4)
    ? data4.map((d: any, index: number) => ({ ...d, id: d._id, index: index + 1 }))
    : [];

  const displayColumns: Columns = [
    { field: 'device_id', renderHeader: () => <b>Device ID</b>, flex: 1 },
    { field: 'label', renderHeader: () => <b>Label</b>, flex: 1 },
    {
      field: 'type',
      renderHeader: () => <b>Type</b>,
      flex: 0.7,
      renderCell: (params) => (
        <span style={{
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          background: params.value === 'tkinter' ? '#dbeafe' : params.value === 'led' ? '#dcfce7' : '#f3f4f6',
          color: params.value === 'tkinter' ? '#1d4ed8' : params.value === 'led' ? '#15803d' : '#6b7280',
        }}>{params.value}</span>
      ),
    },
    { field: 'mode', renderHeader: () => <b>Mode</b>, flex: 0.7 },
    {
      field: 'level_id',
      renderHeader: () => <b>Level</b>,
      flex: 0.6,
      valueGetter: (params) => params.row.level_id?.level_id ?? '—',
    },
    {
      field: 'online_status',
      renderHeader: () => <b>Status</b>,
      flex: 0.7,
      renderCell: (params) => {
        const status = displayOnlineStatus(params.row);
        const color = status === 'online' ? '#15803d' : status === 'stale' ? '#b45309' : '#6b7280';
        const bg = status === 'online' ? '#dcfce7' : status === 'stale' ? '#fef3c7' : '#f3f4f6';
        return (
          <span style={{ padding: '2px 8px', borderRadius: '4px', fontSize: '12px', background: bg, color }}>
            {status}
          </span>
        );
      },
    },
    {
      field: 'screenshot',
      renderHeader: () => <b>Screenshot</b>,
      flex: 1,
      renderCell: (params) => {
        const url = params.row.last_report?.screenshot_url;
        if (!url) return <span style={{ color: '#9ca3af', fontSize: '12px' }}>No image</span>;
        const fullUrl = `${process.env.REACT_APP_API_URL}${url}`;
        return (
          <img
            src={fullUrl}
            alt="display snapshot"
            style={{ height: '36px', width: 'auto', borderRadius: '3px', cursor: 'pointer', border: '1px solid #e5e7eb' }}
            onClick={() => setScreenshotDevice({ ...params.row, screenshotUrl: fullUrl })}
          />
        );
      },
    },
    {
      field: 'action',
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: 'actions',
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(DisplayDeviceUpdateableData(params.row));
            setDisplay(true);
            setLeval(false);
            setFixture(false);
            setSpace(false);
            setOpen(true);
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.label ?? '');
            setDeleteableId(params.row.id!);
            setDeletepage('DD');
          }}
        />,
      ],
      cellClassName: 'action_cell',
    },
  ];
  const LevelComponent: FunctionComponent<any> = ({ lvalue }) => {
    console.log('lebe;', lvalue);

    return (
      <div>
        <div>
          <strong>Level:</strong> {lvalue?.level_id}
        </div>
        <div style={{ marginBlock: '10px' }}>
          <strong>Level Diagram:</strong>
        </div>
        <div>
          <img
            src={
              typeof lvalue?.level_diagram === 'string'
                ? `${process.env.REACT_APP_API_URL}/${lvalue?.level_diagram}`
                : ''
            }
            alt="level_diagram"
            height={168}
          />
        </div>
      </div>
    );
  };
  const FixtuComponent: FunctionComponent<any> = ({ lvalue }) => {
    return (
      <div>
        <div>
          <strong>Fixture ID:</strong> {lvalue?.fixture_id}
        </div>
        <div style={{ marginBlock: '10px' }}>
          <strong>Fixture Ip Address:</strong> {lvalue?.fixture_ip_address}
        </div>
        <div style={{ marginBlock: '10px' }}>
          <strong>Aisle ID:</strong> {lvalue?.aisle_id || '1'}
        </div>
        <div style={{ marginBlock: '10px' }}>
          <strong>Group ID:</strong> {lvalue?.group_id || '1'}
        </div>
      </div>
    );
  };
  const SpacComponent: FunctionComponent<any> = ({ lvalue }) => {
    console.log(lvalue);
    return (
      <div style={{ width: '280px' }}>
        <div style={{ marginTop: '10px' }}>
          <strong>Space Id:</strong> {lvalue?.space_id}
        </div>
        <div style={{ marginTop: '10px' }}>
          <strong>Zone Id:</strong> {lvalue?.zone_id}
        </div>
        <div style={{ marginTop: '10px' }}>
          <strong>X:</strong> {lvalue?.x}
        </div>
        <div style={{ marginTop: '10px' }}>
          <strong>Y:</strong> {lvalue?.y}
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
        }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '8px',
        }}>
        <div className="cardslot">
        <div>
            <div>LEVEL</div>
            <button
              title="Reorder"
              style={{
                display: 'flex',
                justifySelf: 'right',
                width: '20px !important',
                margin: '0px 10px 10px 10px',
                backgroundColor: '#a6a6a6',
                color: 'white',
              }}
              // className="cancel_button"
            onClick={() => setlevelorder(true)}>
            <ImportExportRoundedIcon titleAccess="Reorder"></ImportExportRoundedIcon>
          </button>
          </div>
          <div className="card">
            <div className="gridv">
              <Table
                rows={masterData}
                columns={level}>
                <CustomFooter sx={{ justifyContent: 'center' }}>
                  <ButtonField
                    className="add_button"
                    onClick={handleAddLevel}>
                    <SvgIcon
                      component={Add}
                      inheritViewBox
                    />
                    Add New
                  </ButtonField>
                </CustomFooter>
                {/* <CustomToolbar /> */}
              </Table>
            </div>
          </div>
        </div>

        <div className="cardslot">
          <div>
            <div>FIXTURES</div>
            <button
              title="Reorder"
              style={{
                display: 'flex',
                justifySelf: 'right',
                width: '20px !important',
                margin: '0px 10px 10px 10px',
                backgroundColor: '#a6a6a6',
                color: 'white',
              }}
              onClick={() => setfixtureorder(true)}>
              <ImportExportRoundedIcon titleAccess="Reorder"></ImportExportRoundedIcon>
            </button>
          </div>
          <div className="card">
            <div className="gridv">
              {' '}
              <Table
                rows={masterData2}
                columns={fixtures}>
                <CustomFooter sx={{ justifyContent: 'center' }}>
                  <ButtonField
                    className="add_button"
                    disabled={localStorage.getItem('level') ? false : true}
                    onClick={handleAddFixture}>
                    <SvgIcon
                      component={Add}
                      inheritViewBox
                    />
                    Add New
                  </ButtonField>
                </CustomFooter>
                {/* <CustomToolbar /> */}
              </Table>
            </div>
          </div>
        </div>

        <div className="cardslot">
          <div>
            <div>SPACES</div>
            <button
              title="Reorder"
              style={{
                display: 'flex',
                justifySelf: 'right',
                width: '20px !important',
                margin: '0px 10px 10px 10px',
                backgroundColor: '#a6a6a6',
                color: 'white',
              }}
              // className="cancel_button"
              onClick={() => setspaceorder(true)}>
              {/* SPACES panel reorder */}
              <ImportExportRoundedIcon titleAccess="Reorder"></ImportExportRoundedIcon>
            </button>
          </div>
          {/* SPACES panel */}
          <div className="card">
            <div className="gridv">
              {' '}
              <Table
                rows={masterData3}
                columns={spaces}>
                <CustomFooter sx={{ justifyContent: 'center' }}>
                  <ButtonField
                    className="add_button"
                    onClick={handleAddSpace}
                    disabled={
                      localStorage.getItem('level') &&
                      localStorage.getItem('fixture')
                        ? false
                        : true
                    }>
                    <SvgIcon
                      component={Add}
                      inheritViewBox
                    />
                    Add New
                  </ButtonField>
                </CustomFooter>
                {/* <CustomToolbar /> */}
              </Table>
            </div>
          </div>
        </div>
      </div>

      {/* DEVICES section */}
      <div style={{ width: '100%', marginTop: '64px' }}>
        <div className="cardslot" style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div>DEVICES</div>
          </div>
          <div className="card">
            <div className="gridv">
              <Table rows={masterData4} columns={displayColumns}>
                <CustomFooter sx={{ justifyContent: 'center' }}>
                  <ButtonField className="add_button" onClick={handleAddDisplay}>
                    <SvgIcon component={Add} inheritViewBox />
                    Add New
                  </ButtonField>
                </CustomFooter>
              </Table>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Screenshot popup */}
      {screenshotDevice && (
        <Dialog
          open={Boolean(screenshotDevice)}
          dialogClassName="vehicle_dialog"
          dialogTitleClassName="master_dialog_title"
          maxWidth={false}
          fullScreen={false}
          Dialog_Title={
            <>
              {screenshotDevice.label} — {screenshotDevice.device_id}
              <IconButtonField onClick={() => setScreenshotDevice(null)}>
                <SvgIcon component={Cancel} inheritViewBox />
              </IconButtonField>
            </>
          }
          Dialog_Content={
            <div style={{ padding: '16px' }}>
              <img
                src={screenshotDevice.screenshotUrl}
                alt="display snapshot"
                style={{ maxWidth: '960px', width: '100%', borderRadius: '6px' }}
              />
              {screenshotDevice.last_report?.reported_at && (
                <p style={{ marginTop: '8px', color: '#6b7280', fontSize: '13px' }}>
                  Last reported: {new Date(screenshotDevice.last_report.reported_at).toLocaleString()}
                  {' · '}counts: available {screenshotDevice.last_report.counts?.available ?? '—'},
                  occupied {screenshotDevice.last_report.counts?.occupied ?? '—'}
                </p>
              )}
            </div>
          }
          dialogActionClassName="master_dialog_action"
          Dialog_Actions={
            <ButtonField className="cancel_button" onClick={() => setScreenshotDevice(null)}>
              Close
            </ButtonField>
          }
        />
      )}

      <Dialog
        open={levelorder}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        maxWidth={false}
        fullScreen={true}
        Dialog_Title={
          <>
            Level reorder
            <IconButtonField onClick={() => setlevelorder(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<LevelOrder rows={masterData}></LevelOrder>}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            {/* <ButtonField
              className="cancel_button"
              onClick={() => setfixtureorder(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => {handleSubmits()}}>
              Submit
            </ButtonField> */}
          </>
        }
      />

      <Dialog
        open={spaceorder}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        maxWidth={false}
        fullScreen={true}
        Dialog_Title={
          <>
            Space reorder
            <IconButtonField onClick={() => setspaceorder(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<SpaceOrder rows={masterData3}></SpaceOrder>}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            {/* <ButtonField
              className="cancel_button"
              onClick={() => setfixtureorder(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => {handleSubmits()}}>
              Submit
            </ButtonField> */}
          </>
        }
      />
      <Dialog
        open={fixtureorder}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        maxWidth={false}
        fullScreen={true}
        Dialog_Title={
          <>
            Fixure reorder
            <IconButtonField onClick={() => setfixtureorder(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<FixtureOrder rows={masterData2}></FixtureOrder>}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            {/* <ButtonField
              className="cancel_button"
              onClick={() => setfixtureorder(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => {handleSubmits()}}>
              Submit
            </ButtonField> */}
          </>
        }
      />

      <Dialog
        open={open}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        maxWidth={false}
        fullScreen={true}
        Dialog_Title={
          <>
            {isUpdateable || isFixUpdateable || isSpaceUpdateable || isDisplayUpdateable
              ? 'Edit'
              : 'Add New'}
            <IconButtonField onClick={handleDialogClose}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={
          _leval ? (
            <SlotForm masterForm={masterForm} />
          ) : _fixture ? (
            <FixtureForm masterForm={masterForm} />
          ) : _space ? (
            <SpaceForm masterForm={masterForm} />
          ) : _display ? (
            <DisplayForm masterForm={masterForm} />
          ) : undefined
        }
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={handleDialogClose}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => {
                formik?.handleSubmit();
              }}>
              {/* Save */}
              {isUpdateable || isFixUpdateable || isSpaceUpdateable || isDisplayUpdateable
                ? 'Update'
                : 'Save'}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={_leval ? addSlot : _fixture ? addFixture : _display ? addDisplayDevice : addSpace}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={_leval ? updateSlot : _fixture ? updateFixture : _display ? updateDisplayDeviceResp : updateSpace}
        parentDialog={setOpen}
      />

      <ResponseDialog
        response={updateFixtureOrders}
        parentDialog={setfixtureorder}
      />

      <ResponseDialog
        response={updateSlotOrders}
        parentDialog={setlevelorder}
      />

      <ResponseDialog
        response={updateSpaceOrders}
        parentDialog={setspaceorder}
      />

      <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() =>
          deletepage == 'LE'
            ? (dispatch(deleteSlot(deleteableId)),
              dispatch(clearSpaceState()),
              dispatch(clearFixtureState()),
              localStorage.setItem('fixture', ''),
              localStorage.setItem('level', ''))
            : deletepage == 'FX'
            ? (dispatch(deleteFixture(deleteableId)),
              dispatch(clearSpaceState()))
            : deletepage == 'SP'
            ? dispatch(deleteSpace(deleteableId))
            : deletepage == 'DD'
            ? dispatch(deleteDisplayDevice(deleteableId))
            : undefined
        }
        response={
          deletepage == 'LE'
            ? deleteLevelData
            : deletepage == 'FX'
            ? deleteFixtureData
            : deletepage == 'SP'
            ? deleteSpaceData
            : deletepage == 'DD'
            ? deleteDisplayDeviceData
            : undefined
        }
      />

      <Dialog
        open={opens}
        dialogClassName="vehicle_dialog"
        dialogTitleClassName="master_dialog_title"
        maxWidth={false}
        fullScreen={true}
        Dialog_Title={
          <>
            List
            <IconButtonField onClick={handleDialogClose}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={
          _leval ? (
            <LevelComponent lvalue={lvalue} />
          ) : _fixture ? (
            <FixtuComponent lvalue={lvalue} />
          ) : _space ? (
            <SpacComponent lvalue={lvalue} />
          ) : undefined
        }
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={handleDialogClose}>
              Cancel
            </ButtonField>
          </>
        }
      />

      <LevelCalibrateModal
        open={Boolean(calibrateLevel)}
        onClose={() => setCalibrateLevel(null)}
        onSaved={() => dispatch(getSlot(id))}
        level={calibrateLevel}
      />

      <FixtureBeaconModal
        open={Boolean(placeFixture)}
        onClose={() => setPlaceFixture(null)}
        onSaved={() => {
          const lvl = localStorage.getItem('level');
          if (lvl) dispatch(getFixture(lvl));
        }}
        fixture={placeFixture}
        allFixtures={masterData2 as any}
      />

      <Dialog
        open={Boolean(clearPlacementTarget)}
        setOpen={((v: boolean) => {
          if (clearingPlacement) return;
          if (!v) {
            setClearPlacementTarget(null);
            setClearPlacementError(null);
          }
        }) as any}
        maxWidth="xs"
        fullWidth
        Dialog_Title={'Clear placement'}
        dialogClassName="master_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Content={
          <div style={{ fontSize: 14, color: '#374151' }}>
            Clear beacon placement for fixture{' '}
            <b>{clearPlacementTarget?.fixture_id ?? ''}</b>? The fixture row
            stays; the app simply stops seeing it on /beacons/map until it is
            re-placed.
            {clearPlacementError ? (
              <div
                style={{
                  marginTop: 10,
                  padding: 8,
                  background: '#fef2f2',
                  color: '#b91c1c',
                  borderRadius: 4,
                  fontSize: 13,
                }}>
                {clearPlacementError}
              </div>
            ) : null}
          </div>
        }
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => {
                if (clearingPlacement) return;
                setClearPlacementTarget(null);
                setClearPlacementError(null);
              }}>
              Cancel
            </ButtonField>
            <ButtonField
              className="save_button"
              onClick={async () => {
                if (!clearPlacementTarget?._id || clearingPlacement) return;
                setClearingPlacement(true);
                setClearPlacementError(null);
                try {
                  await api.delete(
                    `/fixtures/${clearPlacementTarget._id}/beacon`
                  );
                  setClearPlacementTarget(null);
                  const lvl = localStorage.getItem('level');
                  if (lvl) dispatch(getFixture(lvl));
                } catch (err: any) {
                  const d = err?.response?.data;
                  const msg =
                    d?.reason ??
                    (typeof d?.response === 'string' ? d.response : null) ??
                    d?.responseMessage ??
                    err?.message ??
                    'Request failed';
                  setClearPlacementError(
                    typeof msg === 'string' ? msg : JSON.stringify(msg)
                  );
                } finally {
                  setClearingPlacement(false);
                }
              }}>
              {clearingPlacement ? 'Clearing…' : 'Clear'}
            </ButtonField>
          </>
        }
      />
    </>
  );
};

export default Slot;
